import React, { useState, useEffect, useContext } from "react";
import axios from "axios";

import URL from "../../common/variables";
import { parseDateString } from "../../common/functions";
import UserContext from "../WelcomeUser/UserContext";
import { TitleSection, BreakLine } from "./UserSection";
import Pagination from "../Pagination/Pagination";

import "./UserBookmarks.scss";

const noteURL = (date, category, slug) => `/notas/${date}/${category}/${slug}`;

const UserBookmarks = () => {
  const { username } = useContext(UserContext);
  const [state, setState] = useState({
    bookmarks: [],
    showPagination: false,
    totalCount: 0,
    loading: false,
    next: null,
    previous: null,
  });

  useEffect(() => {
    getUserBookmarks(`${URL}/bookmarks/${username}/`);
  }, []);

  const getUserBookmarks = (url) => {
    setState((prevState) => ({ ...prevState, loading: true }));

    axios
      .get(url)
      .then((response) => {
        const { count, next, previous, results } = response.data;

        setState((prevState) => ({
          ...prevState,
          bookmarks: results,
          totalCount: count,
          showPagination: count > results.length,
          loading: false,
          next,
          previous,
        }));
      })
      .catch((e) => console.error(e));
  };

  return (
    <div id="user-bookmarks">
      <TitleSection title="Mis notas guardadas" />
      <BreakLine />

      <div>
        <p className="subtitle">{state.totalCount} notas guardadas.</p>
      </div>

      <Pagination getFnRequest={getUserBookmarks} {...state} />

      {state.bookmarks.map((props, index) => (
        <SavedBookmark
          key={index}
          onComplete={() => getUserBookmarks(`${URL}/bookmarks/${username}/`)}
          {...props}
        />
      ))}

      <Pagination getFnRequest={getUserBookmarks} {...state} />
    </div>
  );
};

const SavedBookmark = ({
  category,
  date,
  first_image,
  id,
  title,
  slug,
  onComplete,
}) => {
  const url = noteURL(parseDateString(date), category, slug);

  return (
    <div id="saved-bookmark">
      <div className="row">
        {first_image && (
          <MiniImage title={title} first_image={first_image} url={url} />
        )}

        <div>
          <TimePill date={date} url={url} />
          <Title title={title} url={url} />
        </div>
      </div>

      <div className="footer row">
        <div className="delete-empty col-0 col-sm-8"> </div>
        <DeleteButton id={id} onComplete={onComplete} />
      </div>
    </div>
  );
};

const TimePill = ({ date, url }) => (
  <span className="time-pill">
    <i className="fas fa-clock mr-1"></i>
    {parseDateString(date)}
  </span>
);

const MiniImage = ({ title, first_image, url }) => (
  <a href={url}>
    <img src={first_image} alt={title} className="image" />
  </a>
);

const Title = ({ title, url }) => (
  <a href={url} className="title">
    {title}
  </a>
);

const DeleteButton = ({ id, onComplete }) => {
  const handleClick = () => {
    axios
      .delete(`${URL}/bookmarks/delete/${id}/`)
      .then(() => onComplete())
      .catch((err) => console.error(err));
  };

  return (
    <div className="col-12 col-sm-4" onClick={handleClick}>
      <span class="delete-button">Borrar</span>
    </div>
  );
};

export default UserBookmarks;
